<template>
    <grant-sub-wizard>
        <grant-sub-wizard-tab>
            <form>
                <div class="row mt-3">
                    <div class="col-lg-8">
                        <!-- Upload project description -->
                        <div class="file-form-group row ml-0 mr-0 mb-3">
                            <div class="col-9">
                                <p class="file-caption">{{ $t('proposals.field_title__upload_pdf_fp_project_description') }}</p>
                                <p class="file-subcaption">{{ $t('proposals.field_subtitle__upload_pdf_project_description') }}</p>
                                <label v-if="getError('full_proposal.project_description')" class="error text-danger">{{ getError('full_proposal.project_description') }}</label>
                            </div>
                            <div class="col-3 d-flex justify-content-center align-items-center">
                                <upload-file
                                    v-model="CallForm.files.full_proposal.project_description"
                                    class="upload-file"
                                    section="full_proposal.project_description"
                                    name="full_proposal.project_description"
                                    model-name="Proposal"
                                    v-validate.persist="'required'"
                                    :data-vv-as="$t('proposals.field_title__upload_pdf_fp_project_description')"
                                    :is-editable="CallForm.isFPEditable"
                                    :file-data="CallForm.files.full_proposal.project_description"
                                    :allowed-file-type="'pdf'"
                                >
                                </upload-file>
                            </div>
                        </div>

                        <a :href="fullProposalTemplate[0][$i18n.locale]" target="_blank" class="ml-2 btn btn-simple btn-primary">
                            {{ $t('proposals.button_title__download_full_proposal_template' )}} <i class="tim-icons icon-cloud-download-93 ml-2"></i>
                        </a>
                    </div>
                </div>

                <div class="row mt-3">
                    <div class="col-lg-8">
                        <!-- Upload logical framework -->
                        <div class="file-form-group row ml-0 mr-0 mb-3">
                            <div class="col-9">
                                <p class="file-caption">{{ $t('proposals.field_title__upload_fp_logical_framework') }}</p>
                                <label v-if="getError('full_proposal.logical_framework')" class="error text-danger">{{ getError('full_proposal.logical_framework') }}</label>
                            </div>
                            <div class="col-3 d-flex justify-content-center align-items-center">
                                <upload-file
                                    v-model="CallForm.files.full_proposal.logical_framework"
                                    class="upload-file"
                                    section="full_proposal.logical_framework"
                                    name="full_proposal.logical_framework"
                                    model-name="Proposal"
                                    v-validate.persist="'required'"
                                    :data-vv-as="$t('proposals.field_title__upload_fp_logical_framework')"
                                    :is-editable="CallForm.isFPEditable"
                                    :file-data="CallForm.files.full_proposal.logical_framework"
                                    :allowed-file-type="'xls|xlsx'"
                                >
                                </upload-file>
                            </div>
                        </div>

                        <a :href="fullProposalTemplate[1][$i18n.locale]" target="_blank" class="ml-2 btn btn-simple btn-primary">
                            {{ $t('proposals.button_title__download_full_proposal_logical_framework' )}} <i class="tim-icons icon-cloud-download-93 ml-2"></i>
                        </a>
                        <br />
                        <a :href="fullProposalTemplate[2][$i18n.locale]" target="_blank" class="ml-2 btn btn-simple btn-primary">
                            {{ $t('proposals.button_title__download_full_proposal_list_of_indicators' )}} <i class="tim-icons icon-cloud-download-93 ml-2"></i>
                        </a>
                    </div>
                </div>

                <div class="row mt-3">
                    <div class="col-4">
                        <h4 style="height: 48px">{{ $t('stage_two.logical_framework_indicators_objective_sdg_title') }}</h4>
                        <base-checkbox
                            v-for="index in 17"
                            name="full_proposal_objectives_sdgs"
                            v-validate.persist="'atLeastOne:sdgs'"
                            :data-vv-as="$t('stage_two.logical_framework_indicators_objective_sdg_title')"
                            :disabled="!CallForm.isFPEditable"
                            class="mb-3"
                            v-model="CallForm.model.full_proposal.objectives.sdgs['sdg_' + index.toString().padStart(2, '0')]"
                        >
                            {{ $t('stage_two.logical_framework_indicators_objective_sdg_' + index.toString().padStart(2, '0')) }}
                        </base-checkbox>
                        <label
                            v-if="getError('full_proposal_objectives_sdgs')"
                            class="error text-danger"
                        >
                            {{ getError('full_proposal_objectives_sdgs') }}
                        </label>
                    </div>
                    <div class="col-4">
                        <h4 style="height: 48px">{{ $t('stage_two.logical_framework_indicators_objective_targets_title') }}</h4>
                        <base-checkbox
                            v-for="index in 20"
                            name="full_proposal_objectives_targets"
                            v-validate.persist="'atLeastOne:targets'"
                            :data-vv-as="$t('stage_two.logical_framework_indicators_objective_targets_title')"
                            :disabled="!CallForm.isFPEditable"
                            class="mb-3"
                            v-model="CallForm.model.full_proposal.objectives.targets['target_' + index.toString().padStart(2, '0')]"
                        >
                            {{ $t('stage_two.logical_framework_indicators_objective_targets_' + index.toString().padStart(2, '0')) }}
                        </base-checkbox>
                        <label
                            v-if="getError('full_proposal_objectives_targets')"
                            class="error text-danger"
                        >
                            {{ getError('full_proposal_objectives_targets') }}
                        </label>
                  </div>
                </div>
            </form>
        </grant-sub-wizard-tab>
    </grant-sub-wizard>
</template>
<script>
import Multiselect from 'vue-multiselect';
import { CallForm } from "@/services";
import {GrantSubWizard, GrantSubWizardTab} from '@/components';

export default
{
    components:
    {
        Multiselect,
        GrantSubWizard,
        GrantSubWizardTab,
    },
    data()
    {
        return {
            CallForm,
            sdgs: [],
            targets: [],
            fullProposalTemplate:
            [
                {
                    en: '/files/en/2020/LIFE4BEST_2020_PROPOSAL-REF_Full-proposal_online.docx',
                    fr: '/files/fr/2020/LIFE4BEST_2020_PROP-REF_Proposition-complète_online.docx',
                },
                {
                    en: '/files/en/2020/LIFE4BEST_Logical Framework_PROPOSAL REFERENCE.xls',
                    fr: '/files/fr/2020/LIFE4BEST_Cadre Logique_REFERENCE.xls',
                },
                {
                    en: '/files/en/2020/LIFE4BEST_2020_Indicators_Guidelines.pdf',
                    fr: '/files/fr/2020/LIFE4BEST_2020_Indicateurs_Lignes-directrices.pdf',
                },
            ],
        }
    },
    created()
    {
        for (let i = 1; i <= 17; i++)
        {
            CallForm.model.full_proposal.objectives.sdgs['sdg_' + i.toString().padStart(2, '0')] = !!CallForm.model.full_proposal.objectives.sdgs['sdg_' + i.toString().padStart(2, '0')];
        }

        for (let i = 1; i <= 20; i++)
        {
            CallForm.model.full_proposal.objectives.targets['target_' + i.toString().padStart(2, '0')] = !!CallForm.model.full_proposal.objectives.targets['target_' + i.toString().padStart(2, '0')];
        }

        this.$validator.extend('atLeastOne',
        {
            getMessage: field => 'The ' + field + ' field is required',
            validate: (value, [prop]) =>
            {
                let group = CallForm.model.full_proposal.objectives[prop];

                for (let key in group)
                {
                    if (key === '_forceObject' || key === 'force_object')
                    {
                        continue;
                    }

                    if (group[key])
                    {
                        return true;
                    }
                }

                return value;
            }
        });
    },
    methods:
    {
        getError(fieldName)
        {
            return this.errors.first(fieldName);
        },
        validate()
        {
            return this.$validator.validateAll().then(res => {
                this.$emit('on-validated', res, this.model);
                return res;
            });
        },
    },
}
</script>
<style lang="scss" scoped>
    a
    {
        color: black;

        &:hover
        {
            text-decoration: underline;
        }
    }

    .file-form-group
    {
        padding: 0.625rem 0;
        border: 1px solid #24a46d;
        border-radius: 10px;
    }

    .file-caption
    {
        // font-weight: 500;
    }

    .file-subcaption
    {
        font-size: 0.775rem;
    }

    .count-titles
    {
        counter-reset: cardTitles;

        h4.card-title
        {
            margin-top: 10px;
            counter-increment: cardTitles;

            &:before
            {
                content: counter(cardTitles) '. ';
            }

            .fa-question
            {
                margin-left: 10px;
                display: inline-block;
                width: 24px;
                height: 24px;
                font-size: 13px;
                line-height: 24px;
                text-align: center;
                color: #fff;
                border-radius: 100%;
                background-color: #2083f7;
            }
        }
    }

    .table-bordered th,
    .table-bordered td
    {
        padding: 5px;
    }

    .card-wizard .disabled
    {
        display: block;
    }
</style>
